import React, { Component, PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import actions from "../actions";
import MasterFilter from "./MasterFilter";
import { getSessionDefaultClientId } from "../../../utils/dashboardSession";
import AdvancedFilter from "./AdvancedFilter";
import ImageGrid from "./ImageGrid";
import ImageList from "./ImageList";
import Loader from "../../common/components/Loader";
import ImageLogs from "./ImageLogs";

import TopControls from "./TopControls";
// Otto's image analysis, used ONLY when this grid is the AI Settings > Image Analyse page
// (`imageAnalysisMode`). Not to be confused with the Rekognition "Analyse" in CropperModal, which is manual
// and per-crop and stays exactly as it is on Image Management.
import ImageAnalysisRunBar from "../../imageAnalysis/components/ImageAnalysisRunBar";
import ImageAnalysisFindings from "../../imageAnalysis/components/ImageAnalysisFindings";
import { loadAnalysedBadges } from "../../imageAnalysis/analysedBadges";
import { canUseOttoPage, OTTO_ACTIONS, OTTO_PAGES } from "../../filterAssistant/core/ottoAccess";
import UploadForm from "./Form";
import Portal from "../../common/components/Portal";
import ImageViewModal from "./ImageViewModal";
import BottomControls from "./BottomControls";
import LoadingOverlay from "react-loading-overlay";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import { addToBreadCrumpData, checkPermission, showAlert as showAlertUtil } from "../../../config/utils";
import history from "../../../config/history";
import { entities, RECOMMENDATION_TYPES } from "../../common/constants";
import qs from "query-string";
import AutoSizer from "react-virtualized-auto-sizer";
import moment from "moment";
import { ASSIGN_VIEW_DEFAULT_SORT_KEY, ASSIGN_VIEW_DEFAULT_SORT_ORDER, MASTER_FILTERS, SORT_KEYS } from "../constants";
import { getCapitalRequestLabel, pluralizeLabel } from "../../../utils/capitalRequestLabel";
import { getTableConfig, saveTableConfig } from "../../common/actions";
import BulkImageDownload from "./BulkImageDownload";
import ExportedFiles from "./ExportedFiles";
import { ERROR_COPY } from "../../../config/errorMessages";

export class ImageMain extends PureComponent {
    constructor(props) {
        super(props);
        this.scrollRef = React.createRef();
    }
    entityParamsKey = () =>
        this.props.imageAnalysisMode
            ? "imageAnalysis"
            : this.props.match.params.id || this.props?.mobileRecommendationId || this.props.isSmartChartView
            ? "assign"
            : "master";

    state = {
        showImageClearConfirmModal: false,
        lastVisitedImage: null,
        selectedId: "",
        imageList: [],
        // `{ imageId: { icon, tip } }` - Image Analyse only; see refreshAnalysedBadges.
        imageBadges: null,
        imageParams: this.props.imageReducer.entityParams[this.entityParamsKey()].imageParams,
        sortOrder: this.props.imageReducer.entityParams[this.entityParamsKey()].sortOrder,
        isGridView: this.props.imageReducer.entityParams[this.entityParamsKey()].isGridView,
        showAdvancedFilter: false,
        hasMore: false,
        showSelectBox: true,
        selectedImages: this.props.imageReducer.entityParams[this.entityParamsKey()].selectedImages,
        selectedDeleteImages: [],
        singleImageEdit: {},
        showUploadSingleForm: false,
        showUploadForm: false,
        showImageViewModal: false,
        selectedImage: {},
        isLoading: true,
        isAssignView: this.entityParamsKey() === "assign",
        showConfirmModal: false,
        masterFilters: this.props.imageReducer.entityParams[this.entityParamsKey()].masterFilters,
        favFilter: "all",
        showRecommendation: false,
        isFilterReset: this.props.imageReducer.entityParams[this.entityParamsKey()].isFilterReset,
        showSelected: this.props.imageReducer.entityParams[this.entityParamsKey()].showSelected,
        exportImageLoader: false,
        exportImagePdfLoader: false,
        touchedImageId: null,
        exportImageZipLoader: false,
        showAllImageZipDownloadConfirmation: false,
        isNextPageLoading: false,
        showImageDownloadModal: false,
        openFiles: false
    };

    getRecommendationEntityLabels = () => {
        const { entity, entityData, projectReducer } = this.props;
        const { isAssignView } = this.state;
        const isCR = isAssignView && entity === entities.RECOMMENDATIONS && entityData?.infrastructure_request === "yes";
        const crLabel = getCapitalRequestLabel(projectReducer?.getProjectByIdResponse?.miscellaneous);
        const entityLabel = isCR ? crLabel : "Recommendation";
        const entityPluralLabel = isCR ? pluralizeLabel(crLabel) : "Recommendations";
        return { isCR, entityLabel, entityPluralLabel };
    };

    componentDidMount = async () => {
        try {
            const {
                match: {
                    params: { section, tab }
                },
                location: { search }
            } = this.props;
            const query = qs.parse(search);
            if (query.upload === "true") {
                this.handleAddImage({ preventDefault: () => {} });
            }
            const { imageParams, showSelected, selectedImages } = this.state;
            let index = sessionStorage.getItem("imageIndex") ? parseInt(sessionStorage.getItem("imageIndex")) : 0;
            let selectedImage = sessionStorage.getItem("selectedImage") ? JSON.parse(sessionStorage.getItem("selectedImage")) : null;
            let limit = Math.ceil((index + 1) / imageParams.limit) * imageParams.limit;
            if (selectedImage?.id && section !== "recommendationsinfo") {
                this.setState({ selectedImage: selectedImage, showImageViewModal: true });
                sessionStorage.removeItem("selectedImage");
            }
            await this.getInitialFilters();
            if (this.state.isAssignView) await this.setState({ imageParams: { ...this.state.imageParams, not_assigned: true } });
            await this.refreshImageList(false, limit, false, { previous_image_id: null });
            if (index) {
                let scrollItem = Math.floor(index / 5);
                this.scrollRef.current.scrollToItem(scrollItem);
                this.setState({ touchedImageId: showSelected ? selectedImages[index]?.id : this.state.imageList[index]?.id });
                sessionStorage.removeItem("imageIndex");
            }

            this.fetchTableConfig();
        } catch (error) {
            console.log(error);
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search) {
            const query = qs.parse(this.props.location.search);
            if (query.upload === "true") {
                if (!this.state.showUploadForm) {
                    this.setState({ showUploadForm: true });
                }
                this.props.history.replace({ pathname: this.props.location.pathname });
            }
        }
        // Otto's "already analysed" badge, on the Image Analyse page only. Keyed on the LIST OF IDS rather
        // than on the array: the grid replaces `imageList` on every filter change and appends on every
        // scroll, and re-fetching on identity alone would ask on renders that show the same photographs.
        if (this.props.imageAnalysisMode && prevState && this.imageIdKey(prevState.imageList) !== this.imageIdKey(this.state.imageList)) {
            this.refreshAnalysedBadges();
        }
    }

    imageIdKey = (list = []) => (list || []).map(image => image?.id).join(",");

    // Which of the photographs now on screen Otto has already read. Failure is silent by design (the helper
    // never rejects): a badge is decoration, and the grid it decorates must not depend on filter-ai being up.
    refreshAnalysedBadges = async () => {
        if (!this.props.imageAnalysisMode) return;
        const ids = (this.state.imageList || []).map(image => image?.id).filter(Boolean);
        const imageBadges = await loadAnalysedBadges(ids);
        this.setState({ imageBadges });
    };

    // Function to fetch table config
    async fetchTableConfig() {
        const { masterFilters, imageParams } = this.state;
        const projectIds = masterFilters?.project_ids;
        const clientIds = masterFilters?.client_ids;
        const tradeIds = masterFilters?.trade_ids?.[0];

        const {
            match: {
                params: { section }
            },
            entityData
        } = this.props;

        // Fetch the table config for recommendations info and trade ID 1
        if (section === "recommendationsinfo" && masterFilters?.trade_ids?.length === 1) {
            try {
                const config = await getTableConfig({
                    user_id: localStorage.getItem("userId"),
                    client_id: tradeIds && entityData?.client?.id,
                    table_type: "IMG_RECOM_LAST_VISITED",
                    table_settings: { last_visited_image_id: this.state.selectedImage?.id }
                });

                if (config?.data?.table_settings) {
                    this.setState({ lastVisitedImage: config.data.table_settings.last_visited_image_id });
                }
            } catch (error) {
                console.error("Error fetching recommendations table config:", error);
            }
            return;
        }

        // Handle cases where there are multiple projects or clients
        if (projectIds?.length > 1 && clientIds?.length > 1) {
            this.setState({ lastVisitedImage: null });
            return;
        }

        // Fetch the table config for a single project or client
        try {
            const config = await getTableConfig({
                user_id: localStorage.getItem("userId"),
                project_id: projectIds?.[0] || null,
                client_id: clientIds?.[0],
                table_type: "IMG_MNGMT_LAST_VISITED"
            });

            if (config?.data?.table_settings) {
                this.setState({ lastVisitedImage: config.data.table_settings.last_visited_image_id });
            }
        } catch (error) {
            console.error("Error fetching management table config:", error);
        }
    }

    refreshImageList = async (isFetchMore = false, limit, isFetchPrevious = false, additionalParams = null) => {
        await this.setState({
            isLoading: !isFetchMore ? true : false,
            showLoadButton: false
        });
        let updatedImageParams = { ...this.state.imageParams };
        if (additionalParams) {
            updatedImageParams = { ...updatedImageParams, ...additionalParams };
        }

        if (!isFetchMore && !isFetchPrevious) {
            const resetImageParams = {
                ...updatedImageParams,
                offset: 1,
                limit: limit ? limit : updatedImageParams.limit
            };

            await this.setState({
                imageList: [],
                hasMore: false,
                imageParams: resetImageParams
            });

            this.updateEntityParams();
            this.props.updateSelectedImages(this.state.selectedImages);

            updatedImageParams = resetImageParams;
        }

        const {
            match: {
                params: { id }
            },
            entity,
            isMobRecom = false
        } = this.props;
        if ((id || isMobRecom) && entity !== entities.SMART_CHARTS_IMAGE) {
            if (entity === entities.RECOMMENDATIONS) {
                await this.props.getAllImagesByRecommendation(updatedImageParams, id);
            } else if (entity === entities.NARRATIVES) {
                const {
                    location: { search }
                } = this.props;
                const query = qs.parse(search);
                let params = {
                    ...additionalParams,
                    project_id: query.pid,
                    building_id: query.building_id,
                    narratable_id: query.narratable_id,
                    narratable_type: query.narratable_type
                };
                await this.props.getAllImagesByNarrative(params);
            } else if (entity === entities.ASSET_MANAGEMENT) {
                const {
                    location: { search }
                } = this.props;
                const query = qs.parse(search);
                if (this.props.isInaccessible) await this.props.getAllImagesBySection(updatedImageParams, id, "inaccessible_space");
                else if (this.props?.isStandardImage || this.props?.isSurveyUniformat || this.props?.isGlobalUniformat)
                    await this.props.getAllImagesBySection(
                        {
                            ...updatedImageParams,
                            ...(this.props.isGlobalStandards || this.props?.isGlobalUniformat ? {} : { asset_survey_project_id: id }),
                            ...(this.props?.levelNumber === "5" ? { uniformat_level_id: id, uniformat_leaf_level: 5 } : {})
                        },
                        this?.props?.isGlobalStandards || this?.props?.isGlobalUniformat ? id : query?.parent_id || "",
                        this.props?.isStandardImage
                            ? "client_standards"
                            : this.props.isSurveyUniformat || this.props?.isGlobalUniformat
                              ? "uniformat_level_6s"
                              : ""
                    );
                else if (this.props.isSurveyAsset || this.props?.isMobRecom)
                    await this.props.getAllImagesBySection(
                        updatedImageParams,
                        id,
                        this.props?.isMobRecom ? "mobile_recommendations" : "mobile_asset"
                    );
                else await this.props.getAllImagesBySection(updatedImageParams, id, "assets");
            } else if (entity === entities.SITES) {
                await this.props.getAllImagesBySection(updatedImageParams, id, "sites");
            } else if (entity === entities.BUILDINGS) {
                await this.props.getAllImagesBySection(updatedImageParams, id, "buildings");
            } else if (entity === entities.REGIONS) {
                await this.props.getAllImagesBySection(updatedImageParams, id, "regions");
            }
        } else {
            await this.props.getAllImages(updatedImageParams);
        }
        const { success, images: imageData = [], count, offset: resOffset } = this.props.imageReducer.imagesResponse;
        let images = imageData?.map(img => ({ ...img, offset: resOffset ?? updatedImageParams.offset }));

        if (success) {
            let newImageList = [...this.state.imageList];

            if (isFetchMore) {
                newImageList = [...newImageList, ...images];
            } else if (isFetchPrevious) {
                newImageList = [...images, ...newImageList];
            } else {
                newImageList = images;
            }

            this.setState({
                imageList: newImageList,
                totalCount: count,
                hasMore: newImageList?.length >= count ? false : true,
                imageParams: {
                    ...this.state.imageParams,
                    previous_image_id: null,
                    offset: additionalParams?.previous_image_id ? resOffset : this.state.imageParams.offset
                }
            });
        } else {
            this.setState({ hasMore: false });
        }
        this.setState({ isLoading: false, isNextPageLoading: false });
    };

    getInitialFilters = async () => {
        const {
            match: {
                params: { id },
                surveyAssetClientId
            }
        } = this.props;
        // recommendation pull view
        if ((id || surveyAssetClientId) && this.props?.entity !== entities?.SMART_CHARTS_IMAGE) {
            await this.resetEntityParams();
            const { entityData, entity } = this.props;

            if (entity === entities.RECOMMENDATIONS) {
                let params = {
                    project_ids: [entityData.project?.id],
                    building_ids: [entityData.building?.id]
                };
                // getting trade list based on recommendation (project, building)
                await this.props.getFilterLists(
                    "trades",
                    params,
                    id,
                    this.props?.isSurveyAsset,
                    this.props?.isInaccessible,
                    this.props?.isMobRecom ? "mobile_recommendations" : ""
                );
                const {
                    masterFilterList: { trades }
                } = this.props.imageReducer;
                let trade_ids = trades?.length && trades.some(el => el.id === entityData?.trade?.id) ? [entityData?.trade?.id] : [];
                await this.setState({
                    imageParams: {
                        ...this.state.imageParams,
                        ...params,
                        trade_ids
                    },
                    masterFilters: {
                        trade_ids,
                        system_ids: [],
                        sub_system_ids: [],
                        user_ids: [],
                        image_tag_ids: []
                    }
                });
            } else if (entity === entities.NARRATIVES) {
                const {
                    location: { search }
                } = this.props;
                const query = qs.parse(search);
                let params = {
                    project_ids: [query.pid],
                    building_ids: [query.building_id],
                    trade_ids: [query.trade_id]
                };
                let system_ids = [];
                let sub_system_ids = [];
                if (query.narratable_type === "System") {
                    // getting system list based on narrative (project, building, trade)
                    await this.props.getFilterLists(
                        "systems",
                        params,
                        id,
                        this.props.isSurveyAsset,
                        this.props?.isInaccessible,
                        this.props?.isMobRecom ? "mobile_recommendations" : ""
                    );
                    const {
                        masterFilterList: { systems }
                    } = this.props.imageReducer;
                    system_ids = systems?.length && systems.some(el => el.id === query.narratable_id) ? [query.narratable_id] : [];
                } else if (query.narratable_type === "SubSystem") {
                    // getting system list based on narrative (project, building, trade)
                    await this.props.getFilterLists(
                        "systems",
                        params,
                        id,
                        this.props.isSurveyAsset,
                        this.props?.isInaccessible,
                        this.props?.isMobRecom ? "mobile_recommendations" : ""
                    );
                    const {
                        masterFilterList: { systems }
                    } = this.props.imageReducer;
                    system_ids = systems?.length && systems.some(el => el.id === query.system_id) ? [query.system_id] : [];
                    // getting sub system list based on narrative (project, building, trade, system)
                    await this.props.getFilterLists(
                        "sub_systems",
                        { ...params, system_ids },
                        id,
                        this.props.isSurveyAsset,
                        this.props?.isInaccessible,
                        this.props?.isMobRecom ? "mobile_recommendations" : ""
                    );
                    const {
                        masterFilterList: { sub_systems }
                    } = this.props.imageReducer;
                    sub_system_ids = sub_systems?.length && sub_systems.some(el => el.id === query.narratable_id) ? [query.narratable_id] : [];
                }

                await this.setState({
                    imageParams: {
                        ...this.state.imageParams,
                        ...params,
                        system_ids,
                        sub_system_ids
                    },
                    masterFilters: {
                        system_ids,
                        sub_system_ids,
                        user_ids: [],
                        image_tag_ids: []
                    }
                });
            } else if (entity === entities.ASSET_MANAGEMENT || entity === entities.BUILDINGS) {
                let params = {
                    client_ids: entityData.client.id ? [entityData.client.id] : []
                };

                if (entity === entities.ASSET_MANAGEMENT) {
                    const {
                        location: { search },
                        isGlobalStandards = false,
                        isStandardImage = false,
                        isSurveyUniformat = false,
                        isGlobalUniformat = false
                    } = this.props;
                    const query = qs.parse(search);
                    if (this.props.isStandardImage || isSurveyUniformat || isGlobalUniformat) {
                        await this.props.getFilterLists(
                            isStandardImage ? "client_standards" : `uniformat_level_${this.props?.levelNumber}s`,
                            {
                                ...params,
                                client_ids: params.client_ids,
                                not_assigned: true,
                                ...(isGlobalStandards || isGlobalUniformat ? {} : { asset_survey_project_id: id })
                            },
                            isGlobalStandards || isGlobalUniformat ? id : query?.parent_id || "",
                            this.props.isSurveyAsset,
                            this.props?.isInaccessible,
                            isStandardImage
                                ? "client_standards"
                                : isSurveyUniformat || isGlobalUniformat
                                  ? `uniformat_level_${this.props?.levelNumber}s`
                                  : ""
                        );
                        const Id = isGlobalStandards || isGlobalUniformat ? id : query?.parent_id || "";
                        if (isGlobalUniformat || isSurveyUniformat) {
                            const {
                                masterFilterList: { uniformat_level_6s, uniformat_level_5s }
                            } = this.props.imageReducer;
                            let uniformatIds = uniformat_level_6s?.length && uniformat_level_6s?.some(el => el?.id === Id) ? [Id] : [];
                            let uniformat5Ids = uniformat_level_5s?.length && uniformat_level_5s?.some(el => el?.id === Id) ? [Id] : [];
                            params = { ...params, uniformat_level_6_ids: uniformatIds, uniformat_level_5_ids: uniformat5Ids };
                        } else {
                            const {
                                masterFilterList: { client_standards }
                            } = this.props.imageReducer;
                            let clientstandardIds = client_standards?.length && client_standards?.some(el => el?.id === Id) ? [Id] : [];
                            params = { ...params, client_standard_ids: clientstandardIds };
                        }
                    } else {
                        await this.props.getFilterLists(
                            "sites",
                            { client_ids: params.client_ids },
                            id,
                            this.props.isSurveyAsset,
                            this.props?.isInaccessible,
                            this.props?.isMobRecom ? "mobile_recommendations" : ""
                        );
                        params = {
                            ...params,
                            ...(this.props?.isMobRecom ? {} : { is_asset_image: true }),
                            ...(this.props?.isMobRecom ? { project_ids: [entityData?.project_id?.id] } : { site_ids: [entityData?.site?.id] })
                        };
                    }
                } else if (entity === entities.BUILDINGS) {
                    await this.props.getFilterLists(
                        "buildings",
                        { client_ids: params.client_ids },
                        id,
                        this.props.isSurveyAsset,
                        this.props?.isInaccessible,
                        this.props?.isMobRecom ? "mobile_recommendations" : ""
                    );
                    params = { ...params, building_ids: [entityData?.id] };
                }

                await this.setState({
                    imageParams: {
                        ...this.state.imageParams,
                        ...params
                    },
                    masterFilters: { ...this.state.masterFilters, ...params }
                });
            } else if (entity === entities.SITES) {
                let params = {
                    client_ids: [entityData.client.id],
                    site_ids: [entityData.id]
                };

                await this.props.getFilterLists(
                    "sites",
                    { client_ids: params.client_ids },
                    id,
                    this.props.isSurveyAsset,
                    this.props?.isInaccessible,
                    this.props?.isMobRecom ? "mobile_recommendations" : ""
                );

                await this.setState({
                    imageParams: {
                        ...this.state.imageParams,
                        ...params
                    },
                    masterFilters: { ...this.state.masterFilters, ...params }
                });
            } else if (entity === entities.REGIONS) {
                let params = {
                    client_ids: [entityData.client.id],
                    region_ids: [entityData.id]
                };

                await this.props.getFilterLists(
                    "regions",
                    { client_ids: params.client_ids },
                    id,
                    this.props.isSurveyAsset,
                    this.props?.isInaccessible,
                    this.props?.isMobRecom ? "mobile_recommendations" : ""
                );

                await this.setState({
                    imageParams: {
                        ...this.state.imageParams,
                        ...params
                    },
                    masterFilters: { ...this.state.masterFilters, ...params }
                });
            }
        } else {
            //smartchart image pull view
            const { entity } = this.props;
            if (entity === entities.SMART_CHARTS || entity === entities.SMART_CHARTS_IMAGE) {
                if (this.props?.selectedFilters?.client_ids?.length) {
                    await this.setState({
                        imageParams: {
                            ...this.state.imageParams,
                            ...(this.props?.selectedFilters || {}),
                            client_ids: [...this.props.selectedFilters.client_ids]
                        },
                        masterFilters: {
                            ...this.state.masterFilters,
                            ...(this.props?.selectedFilters || {}),
                            client_ids: [...this.props.selectedFilters.client_ids]
                        }
                    });
                }
            } else {
                //master view
                if (!this.state.isFilterReset && !this.isMasterFiltered()) {
                    await this.props.getFilterLists(
                        "clients",
                        {},
                        id,
                        this.props.isSurveyAsset,
                        this.props?.isInaccessible,
                        this.props?.isMobRecom ? "mobile_recommendations" : ""
                    );
                    const defaultClient = getSessionDefaultClientId() || this.props.imageReducer.defaultClient;
                    if (defaultClient) {
                        await this.setState({
                            imageParams: {
                                ...this.state.imageParams,
                                client_ids: [defaultClient]
                            },
                            masterFilters: { ...this.state.masterFilters, client_ids: [defaultClient] }
                        });
                    }
                }
            }
        }
    };
    isMasterFiltered = () => {
        let flag = false;
        MASTER_FILTERS.forEach(item => {
            if (this.state.imageParams[item.paramKey]?.length) {
                flag = true;
                return;
            }
        });
        return flag;
    };

    updateMasterFilters = masterFilters => {
        // const { masterFilters } = this.state;
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    ...masterFilters,
                    offset: 1
                },
                masterFilters,
                selectedImages: []
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };

    handleGlobalSearch = search => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    search,
                    offset: 1
                }
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };

    handleLimitChange = value => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    offset: 1,
                    limit: value
                }
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };

    updateAdvancedFilters = filters => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    offset: 1,
                    filters
                },
                selectedImages: []
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };

    updateRecomAssignedFilter = assigned => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    offset: 1,
                    recommendation_image_assigned_true: assigned || null
                },
                selectedImages: []
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };
    updateClientStandardImage = assigned => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    offset: 1,
                    client_standard_images: assigned || null
                },
                selectedImages: []
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };
    updateUniformatImage = (key, assigned) => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    offset: 1,
                    [key]: assigned || null
                },
                selectedImages: []
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };
    updateImageModifyFilter = assigned => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    offset: 1,
                    image_modify_filter: assigned || null
                },
                selectedImages: []
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };
    updateAssetImage = assigned => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    offset: 1,
                    is_asset_image: assigned || null
                },
                selectedImages: []
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };

    fetchMoreImages = () => {
        const { imageParams } = this.state;
        this.setState(
            {
                imageParams: { ...imageParams, offset: imageParams.offset + 1 },
                isNextPageLoading: true
            },
            () => this.refreshImageList(true)
        );
    };

    toggleAdvancedFilters = () => {
        this.setState({ showAdvancedFilter: !this.state.showAdvancedFilter });
    };

    setGridView = async bool => {
        await this.setState({ isGridView: bool });
        this.updateEntityParams();
    };

    handleMultiSelectImage = (img, isChecked) => {
        const { selectedImages } = this.state;
        this.setState({ selectedImages: isChecked ? [...selectedImages, img] : selectedImages.filter(t => t.id !== img.id) }, () => {
            this.props.updateSelectedImages(this.state.selectedImages);
            this.updateEntityParams();
        });
    };

    handleSelectAll = async isChecked => {
        const { isSmartChartView = false } = this.props;
        let temp = this.state.imageList;
        if (this.state.isAssignView && !isSmartChartView) {
            temp = temp.filter(img => img.not_assigned);
        }
        await this.setState({ selectedImages: isChecked ? temp : [] });
        if (!isChecked) {
            this.setState({ showSelected: false });
        }
        this.props.updateSelectedImages(this.state.selectedImages);
    };

    handleSort = sortValue => {
        this.setState(
            {
                imageParams: {
                    ...this.state.imageParams,
                    offset: 1,
                    order: sortValue ? { [sortValue]: this.state.sortOrder } : null
                }
            },
            () => {
                this.updateEntityParams();
                this.refreshImageList();
            }
        );
    };
    handleSortOrder = order => {
        const { imageParams } = this.state;
        this.setState({ sortOrder: order });
        if (imageParams.order) {
            this.setState(
                {
                    imageParams: {
                        ...imageParams,
                        offset: 1,
                        order: { [Object.keys(imageParams.order)[0]]: order }
                    }
                },
                () => {
                    this.updateEntityParams();
                    this.refreshImageList();
                }
            );
        }
    };

    handleMultiEditImage = e => {
        e.preventDefault();
        this.setState({ showUploadForm: !this.state.showUploadForm });
    };

    handleEditImage = async (data, key) => {
        if (key === "next" || key === "prev") {
            this.setState({ singleEditimage: [data], touchedImageId: data.id, showUploadSingleForm: true, lastVisitedImage: data?.id });
        } else {
            this.setState({
                singleEditimage: [data],
                touchedImageId: data.id,
                showUploadSingleForm: !this.state.showUploadSingleForm,
                lastVisitedImage: data?.id
            });
        }
        const {
            match: {
                params: { section }
            },
            entityData
        } = this.props;

        try {
            await this.handleSaveTableConfig(data);
        } catch (error) {
            console.error("Error saving or fetching table config:", error);
        }
    };

    handleDeleteImage = async images => {
        // checking if the selected image mapped to any recommendations
        let recomAssigned = images.some(img => img?.recommendations?.length);
        if (recomAssigned) {
            const { entityPluralLabel } = this.getRecommendationEntityLabels();
            this.setState({ alertMessage: `Image(s) cannot be deleted. It is used by one or more ${entityPluralLabel.toLowerCase()}` }, () =>
                this.showLongAlert()
            );
        } else {
            this.setState({
                showConfirmModal: true,
                selectedDeleteImages: images
            });
        }
    };

    renderConfirmationModal = () => {
        const { showConfirmModal } = this.state;
        if (!showConfirmModal) return null;
        let selected_count = this.state.selectedDeleteImages.length;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={
                            selected_count == 1 || selected_count == 0
                                ? `Do you want to delete this image: `
                                : ` Do you want to delete ${selected_count} images:`
                        }
                        message={
                            selected_count == 1 || selected_count == 0
                                ? `This action cannot be reverted, are you sure that you need to delete this image?`
                                : `This action cannot be reverted, are you sure that you need to delete these images?`
                        }
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={this.deleteImageOnConfirm}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    deleteImageOnConfirm = async () => {
        const { selectedDeleteImages, selectedImages } = this.state;
        let { imageList } = this.state;
        this.setState({
            showConfirmModal: false,
            isLoading: true
        });
        let imgIds = selectedDeleteImages.map(img => img.id);
        await this.props.deleteImage({ deleteImages: imgIds });
        const { status, message } = this.props.imageReducer.deleteImageResponse;

        if (!status) {
            await this.setState({
                alertMessage: message || ERROR_COPY.GENERIC,
                showConfirmModal: false
            });
            this.showLongAlert();
        } else {
            imageList = imageList.filter(img => !imgIds.includes(img.id));
            await this.setState({
                showConfirmModal: false,
                alertMessage: message,
                selectedImages: selectedImages?.filter(img => !imgIds.includes(img.id)),
                selectedDeleteImages: [],
                showUploadForm: false,
                selectedImage: {},
                showImageViewModal: false,
                showUploadSingleForm: false,
                imageList,
                showSelected: false
            });
            this.showLongAlert();
        }

        this.setState({
            isLoading: false
        });
    };

    showLongAlert = () => showAlertUtil(this.state.alertMessage, true);

    handleAddImage = e => {
        e.preventDefault();
        this.setState({ selectedImages: [], selectedImage: {}, showUploadForm: !this.state.showUploadForm });
    };

    renderUploadModal = () => {
        const { showUploadForm, selectedImages, selectedImage } = this.state;
        if (!showUploadForm) return null;
        const { entityData, entity, AssetName } = this.props;
        let assetName = "";
        if (entity === entities.RECOMMENDATIONS && entityData.recommendation_type === RECOMMENDATION_TYPES.ASSET && AssetName) {
            assetName = this.props.AssetName;
        }
        return (
            <Portal
                body={
                    <UploadForm
                        assetName={assetName}
                        isAssignView={this.state.isAssignView}
                        selectedImages={selectedImages}
                        refreshImageList={this.refreshImageList}
                        onCancel={() => this.setState({ showUploadForm: false })}
                        handleDelete={this.handleDeleteImage}
                        hasDelete={checkPermission("forms", "image_management", "delete")}
                        handleNext={this.handleNextForm}
                        handlePrev={this.handlePrevForm}
                        imageList={this.state.imageList}
                        entityData={this.props.entityData}
                        updateImagesAfterEdit={this.updateImagesAfterEdit}
                        updateImageListAfterUpdate={this.updateImageListAfterUpdate}
                        isAsset={entity === entities.ASSET_MANAGEMENT}
                        entity={entity}
                    />
                }
                onCancel={() => this.setState({ showUploadForm: false })}
            />
        );
    };

    renderUploadSingleModal = () => {
        const { showUploadSingleForm, singleEditimage } = this.state;
        if (!showUploadSingleForm) return null;
        const { entityData, entity, AssetName } = this.props;
        let assetName = "";
        if (entity === entities.RECOMMENDATIONS && entityData.recommendation_type === RECOMMENDATION_TYPES.ASSET && AssetName) {
            assetName = this.props.AssetName;
        }
        return (
            <Portal
                body={
                    <UploadForm
                        assetName={assetName}
                        isAssignView={this.state.isAssignView}
                        selectedImages={singleEditimage}
                        refreshImageList={this.refreshImageList}
                        onCancel={() => this.setState({ showUploadSingleForm: false })}
                        handleDelete={this.handleDeleteImage}
                        hasDelete={checkPermission("forms", "image_management", "delete")}
                        handleNext={this.handleNextForm}
                        handlePrev={this.handlePrevForm}
                        imageList={this.state.imageList}
                        entityData={this.props.entityData}
                        updateImagesAfterEdit={this.updateImagesAfterEdit}
                        updateImageListAfterUpdate={this.updateImageListAfterUpdate}
                    />
                }
                onCancel={() => this.setState({ showUploadSingleForm: false })}
            />
        );
    };

    handleSaveTableConfig = async data => {
        const {
            match: {
                params: { section }
            },
            entityData
        } = this.props;
        const { masterFilters } = this.state;

        const recomImagesClientId = entityData?.client?.id;
        const clientIds = masterFilters?.client_ids?.[0];

        const tableType =
            section === "recommendationsinfo" && masterFilters?.trade_ids?.length === 1
                ? "IMG_RECOM_LAST_VISITED"
                : masterFilters?.project_ids?.length <= 1 && masterFilters?.client_ids?.length === 1
                  ? "IMG_MNGMT_LAST_VISITED"
                  : null;

        if (tableType) {
            await saveTableConfig({
                user_id: localStorage.getItem("userId"),
                client_id: tableType === "IMG_RECOM_LAST_VISITED" ? recomImagesClientId : clientIds,
                table_type: tableType,
                table_settings: { last_visited_image_id: data?.id }
            });
        }
    };

    // function to view last visited image
    handleViewLastVisitedImage = async () => {
        const {
            match: {
                params: { section }
            }
        } = this.props;

        const imageId = this.state.lastVisitedImage;
        try {
            this.setState({ isLoading: true, touchedImageId: this.state.lastVisitedImage });

            const existingImage = this.state.imageList?.find(img => img?.id === imageId);

            if (existingImage) {
                const touchedImageIndex = this.state.imageList?.findIndex(image => image.id === imageId);

                let divideIndex;
                if (section === "recommendationsinfo") {
                    divideIndex = Math.floor(touchedImageIndex / 6);
                } else {
                    divideIndex = Math.floor(touchedImageIndex / 5);
                }

                this.setState({
                    selectedImage: existingImage,
                    showImageViewModal: true
                });

                this.scrollRef.current.scrollToItem(divideIndex, "center");
            } else {
                this.setState({ showImageClearConfirmModal: true });
            }
        } catch (error) {
            this.setState({ alertMessage: ERROR_COPY.GENERIC }, () => this.showLongAlert());
        } finally {
            this.setState({ isLoading: false });
        }
    };

    // alert  modal when lastvisited image state not exist
    handleImageClearConfirmResponse = async confirm => {
        const {
            match: {
                params: { section }
            }
        } = this.props;
        if (confirm) {
            this.setState({ isLoading: true });
            const imageId = this.state.lastVisitedImage;
            const { offset } = this.props.imageReducer.imagesResponse;

            await this.setState({
                imageParams: {
                    ...this.state.imageParams,
                    offset: offset,
                    limit: this.state.imageParams.limit
                },
                touchedImageId: imageId,
                showImageClearConfirmModal: false
            });

            await this.refreshImageList(false, this.state.imageParams.limit, false, { previous_image_id: imageId });
            const { images } = this.props.imageReducer.imagesResponse;

            const fetchedImage = images?.find(img => img?.id === imageId);

            if (fetchedImage) {
                const touchedImageIndex = this.state.imageList.findIndex(img => img?.id === imageId);

                let fetchedDivideIndex;
                if (section === "recommendationsinfo") {
                    fetchedDivideIndex = Math.floor(touchedImageIndex / 6);
                } else {
                    fetchedDivideIndex = Math.floor(touchedImageIndex / 5);
                }
                this.setState({
                    selectedImage: fetchedImage,
                    showImageViewModal: true
                });
                this.setState({ isLoading: false });

                this.scrollRef.current.scrollToItem(fetchedDivideIndex, "center");
            } else {
                this.setState({ alertMessage: "The last visited image does not exist" }, () => this.showLongAlert());
            }
        } else {
            this.setState({ showImageClearConfirmModal: false });
        }
    };

    renderImageClearConfirmationModal = () => {
        const { showImageClearConfirmModal } = this.state;
        if (!showImageClearConfirmModal) return null;

        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={`"View Last Visited Image" will refresh the image gallery with new images, clearing the current list`}
                        message={"Are you sure you want to proceed?"}
                        onNo={() => this.handleImageClearConfirmResponse(false)}
                        onYes={() => this.handleImageClearConfirmResponse(true)}
                        cancel={() => this.handleImageClearConfirmResponse(false)}
                    />
                }
                onCancel={() => this.handleImageClearConfirmResponse(false)}
            />
        );
    };

    fetchPreviousImages = async () => {
        const {
            match: {
                params: { section }
            }
        } = this.props;
        const { imageList } = this.state;
        const offset = imageList[0]?.offset - 1;
        if (offset < 1) return;
        await this.refreshImageList(false, null, true, { offset });
        const existingImage = this.state.imageList?.find(img => img?.id === this.state.lastVisitedImage);
        if (existingImage) {
            const touchedImageIndex = this.state.imageList.findIndex(img => img?.id === this.state.lastVisitedImage);

            let divideIndex;
            if (section === "recommendationsinfo") {
                divideIndex = Math.floor(touchedImageIndex / 6);
            } else {
                divideIndex = Math.floor(touchedImageIndex / 5);
            }
            this.scrollRef.current.scrollToItem(divideIndex, "center");
        }
    };

    viewImageModal = async data => {
        const {
            match: {
                params: { section }
            },
            entityData
        } = this.props;

        this.setState({
            selectedImage: data,
            showImageViewModal: true,
            touchedImageId: data?.id,
            lastVisitedImage: data?.id,
            selectedId: ""
        });

        try {
            await this.handleSaveTableConfig(data);
        } catch (error) {
            console.error("Error saving or fetching table config:", error);
        }
    };

    toggleLogsModal = () => {
        this.setState({
            openLogs: !this.state.openLogs
        });
    };

    renderLogsModal = () => {
        const { openLogs, imageParams } = this.state;
        if (!openLogs) return null;
        return <Portal body={<ImageLogs onCancel={this.toggleLogsModal} filterParams={imageParams} />} onCancel={this.toggleLogsModal} />;
    };
    editFunction = (editedData, editedImages) => {
        // this.setState({ selectedId: id });
        const {
            imageReducer: {
                projectList: { projects }
            },
            assetReducer: { dropDownList }
        } = this.props;
        editedImages.forEach(({ id }) => {
            this.setState(prevState => {
                const imageList = prevState.imageList.map(item => {
                    if (item.id === id) {
                        item.image_labels = editedData?.image_labels;
                        item.image_text = editedData?.image_text;

                        return item;
                    } else return item;
                });

                const selectedImages = prevState.selectedImages.map(item => {
                    if (item.id === id) {
                        item.image_labels = editedData?.image_labels;
                        item.image_text = editedData?.image_text;
                        return item;
                    } else return item;
                });

                return { imageList, selectedImages };
            });
        });
    };

    renderImageViewModal = () => {
        const { showImageViewModal, selectedImage, isAssignView, showSelected, selectedImages, imageList } = this.state;
        const { entityPluralLabel, entityLabel } = this.getRecommendationEntityLabels();
        let hasExport = checkPermission("forms", "image_management", "export");
        if (!showImageViewModal) return null;
        return (
            <Portal
                body={
                    <ImageViewModal
                        hasEdit={checkPermission("forms", "image_management", "edit") && this.props?.entity !== entities.SMART_CHARTS_IMAGE}
                        selectedImg={selectedImage}
                        onCancel={() => this.setState({ showImageViewModal: false })}
                        handleEdit={this.handleEditImage}
                        handleFavClick={this.handleFavClick}
                        viewRecommendations={this.viewRecommendations}
                        entityPluralLabel={entityPluralLabel}
                        entityLabel={entityLabel}
                        isAssignView={isAssignView}
                        handleNext={this.handleNext}
                        handlePrev={this.handlePrev}
                        imageList={showSelected ? selectedImages : imageList}
                        handleInputCaptionData={this.handleInputCaptionData}
                        viewAssets={this.viewAssets}
                        refreshImageList={this.refreshImageList}
                        editFunction={this.editFunction}
                        hasExport={hasExport}
                        aiAnalyzeContent={
                            this.props.imageAnalysisMode ? (
                                <ImageAnalysisFindings
                                    // keyed by image so paging next/prev in the viewer reloads the reading
                                    key={selectedImage?.id}
                                    imageUploadId={selectedImage?.id}
                                    canAnalyse={canUseOttoPage(OTTO_PAGES.IMAGE_ANALYSIS, OTTO_ACTIONS.MANAGE)}
                                    // Analysing from the viewer marks the photo in the grid behind it, so
                                    // closing the viewer does not reveal a stale "never analysed" tile.
                                    onAnalysed={this.refreshAnalysedBadges}
                                />
                            ) : null
                        }
                    />
                }
                onCancel={() => this.setState({ showImageViewModal: false })}
            />
        );
    };

    resetAll = () => {
        const { limit, offset } = this.state.imageParams;
        const {
            match: {
                params: { id }
            },
            entityData
        } = this.props;
        const { isAssignView } = this.state;
        this.setState({
            imageParams: {
                ...this.state.imageParams,
                offset: 1,
                order: isAssignView ? { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER } : { "image_upload.created_date": "desc" }
            },
            sortOrder: isAssignView ? ASSIGN_VIEW_DEFAULT_SORT_ORDER : "desc",
            showAdvancedFilter: false,
            selectedImages: []
        });
        if (id) {
            const { entity } = this.props;
            if (entity === entities.RECOMMENDATIONS) {
                this.setState({
                    imageParams: {
                        limit,
                        offset: 1,
                        order: { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER },
                        filters: {},
                        search: "",
                        project_ids: [entityData.project?.id],
                        building_ids: [entityData.building?.id],
                        trade_ids: [entityData.trade?.id],
                        not_assigned: true
                    },
                    sortOrder: ASSIGN_VIEW_DEFAULT_SORT_ORDER,
                    masterFilters: {
                        project_ids: [entityData.project?.id],
                        building_ids: [entityData.building?.id],
                        trade_ids: [entityData.trade?.id],
                        system_ids: [],
                        sub_system_ids: [],
                        user_ids: [],
                        image_tag_ids: [],
                        client_ids: [],
                        region_ids: [],
                        site_ids: []
                    }
                });
            } else if (entity === entities.NARRATIVES) {
                const {
                    location: { search }
                } = this.props;
                const query = qs.parse(search);
                this.setState({
                    imageParams: {
                        limit,
                        offset: 1,
                        order: { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER },
                        filters: {},
                        search: "",
                        project_ids: [query.pid],
                        building_ids: [query.building_id],
                        trade_ids: [query.trade_id],
                        not_assigned: true
                    },
                    sortOrder: ASSIGN_VIEW_DEFAULT_SORT_ORDER,
                    masterFilters: {
                        project_ids: [query.pid],
                        building_ids: [query.building_id],
                        trade_ids: [query.trade_id],
                        system_ids: [],
                        sub_system_ids: [],
                        user_ids: [],
                        image_tag_ids: [],
                        client_ids: [],
                        region_ids: [],
                        site_ids: []
                    }
                });
            } else if (entity === entities.ASSET_MANAGEMENT) {
                this.setState({
                    imageParams: {
                        limit,
                        offset: 1,
                        order: { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER },
                        search: "",
                        filters: {},
                        client_ids: entityData ? [entityData.client.id] : [],
                        not_assigned: true
                    },
                    sortOrder: ASSIGN_VIEW_DEFAULT_SORT_ORDER,
                    masterFilters: {
                        client_ids: entityData ? [entityData.client.id] : [],
                        building_ids: [],
                        trade_ids: [],
                        system_ids: [],
                        sub_system_ids: [],
                        user_ids: [],
                        image_tag_ids: [],
                        project_ids: [],
                        region_ids: [],
                        site_ids: [],
                        uniformat_level_6_ids: [],
                        uniformat_level_5_ids: []
                    }
                });
            } else if (entity === entities.SITES) {
                this.setState({
                    imageParams: {
                        limit,
                        offset: 1,
                        order: { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER },
                        search: "",
                        filters: {},
                        client_ids: entityData ? [entityData.client.id] : [],
                        site_ids: entityData ? [entityData?.id] : [],
                        not_assigned: true
                    },
                    sortOrder: ASSIGN_VIEW_DEFAULT_SORT_ORDER,
                    masterFilters: {
                        client_ids: entityData ? [entityData.client.id] : [],
                        building_ids: [],
                        trade_ids: [],
                        system_ids: [],
                        sub_system_ids: [],
                        user_ids: [],
                        image_tag_ids: [],
                        project_ids: [],
                        region_ids: [],
                        site_ids: entityData ? [entityData?.id] : []
                    }
                });
            } else if (entity === entities.BUILDINGS) {
                this.setState({
                    imageParams: {
                        limit,
                        offset: 1,
                        order: { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER },
                        search: "",
                        filters: {},
                        client_ids: entityData ? [entityData.client.id] : [],
                        building_ids: entityData ? [entityData?.id] : [],
                        not_assigned: true
                    },
                    sortOrder: ASSIGN_VIEW_DEFAULT_SORT_ORDER,
                    masterFilters: {
                        client_ids: entityData ? [entityData.client.id] : [],
                        building_ids: entityData ? [entityData?.id] : [],
                        trade_ids: [],
                        system_ids: [],
                        sub_system_ids: [],
                        user_ids: [],
                        image_tag_ids: [],
                        project_ids: [],
                        region_ids: [],
                        site_ids: []
                    }
                });
            } else if (entity === entities.REGIONS) {
                this.setState({
                    imageParams: {
                        limit,
                        offset: 1,
                        order: { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER },
                        search: "",
                        filters: {},
                        client_ids: entityData ? [entityData.client.id] : [],
                        region_ids: entityData ? [entityData?.id] : [],
                        not_assigned: true
                    },
                    sortOrder: ASSIGN_VIEW_DEFAULT_SORT_ORDER,
                    masterFilters: {
                        client_ids: entityData ? [entityData.client.id] : [],
                        building_ids: [],
                        trade_ids: [],
                        system_ids: [],
                        sub_system_ids: [],
                        user_ids: [],
                        image_tag_ids: [],
                        project_ids: [],
                        region_ids: entityData ? [entityData?.id] : [],
                        site_ids: []
                    }
                });
            }
        } else {
            const defaultClient = getSessionDefaultClientId() || this.props.imageReducer.defaultClient;
            this.setState({
                imageParams: {
                    limit,
                    offset: 1,
                    order: { "image_upload.created_date": "desc" },
                    sortOrder: "desc",
                    search: "",
                    filters: {},
                    client_ids: defaultClient ? [defaultClient] : []
                },
                masterFilters: {
                    client_ids: defaultClient ? [defaultClient] : [],
                    building_ids: [],
                    trade_ids: [],
                    system_ids: [],
                    sub_system_ids: [],
                    user_ids: [],
                    image_tag_ids: [],
                    project_ids: [],
                    region_ids: [],
                    site_ids: []
                },
                isFilterReset: true
            });
        }
        this.updateEntityParams();
        this.refreshImageList();
    };

    resetAllFilters = () => {
        const { limit, offset, order } = this.state.imageParams;
        const {
            match: {
                params: { id }
            },
            entityData
        } = this.props;
        this.setState({ selectedImages: [] });
        if (id) {
            const { entity } = this.props;
            if (entity === entities.RECOMMENDATIONS) {
                this.setState(
                    {
                        imageParams: {
                            limit,
                            offset,
                            order,
                            filters: {},
                            search: "",
                            project_ids: [entityData.project?.id],
                            building_ids: [entityData.building?.id],
                            trade_ids: [entityData.trade?.id]
                        },
                        masterFilters: {
                            project_ids: [entityData.project?.id],
                            building_ids: [entityData.building?.id],
                            trade_ids: [entityData.trade?.id],
                            system_ids: [],
                            sub_system_ids: [],
                            user_ids: [],
                            image_tag_ids: [],
                            client_ids: [],
                            region_ids: [],
                            site_ids: []
                        },
                        showAdvancedFilter: false
                    },
                    () => this.refreshImageList()
                );
            } else if (entity === entities.NARRATIVES) {
                const {
                    location: { search }
                } = this.props;
                const query = qs.parse(search);
                this.setState(
                    {
                        imageParams: {
                            limit,
                            offset,
                            order,
                            filters: {},
                            search: "",
                            project_ids: [query.pid],
                            building_ids: [query.building_id],
                            trade_ids: [query.trade_id]
                        },
                        masterFilters: {
                            project_ids: [query.pid],
                            building_ids: [query.building_id],
                            trade_ids: [query.trade_id],
                            system_ids: [],
                            sub_system_ids: [],
                            user_ids: [],
                            image_tag_ids: [],
                            client_ids: [],
                            region_ids: [],
                            site_ids: []
                        },
                        showAdvancedFilter: false
                    },
                    () => this.refreshImageList()
                );
            }
        } else {
            const defaultClient = getSessionDefaultClientId() || this.props.imageReducer.defaultClient;
            this.setState(
                {
                    imageParams: { limit, offset, order, search: "", filters: {}, client_ids: defaultClient ? [defaultClient] : [] },
                    masterFilters: {
                        client_ids: defaultClient ? [defaultClient] : [],
                        building_ids: [],
                        trade_ids: [],
                        system_ids: [],
                        sub_system_ids: [],
                        user_ids: [],
                        image_tag_ids: [],
                        project_ids: [],
                        region_ids: [],
                        site_ids: [],
                        uniformat_level_6_ids: [],
                        uniformat_level_5_ids: []
                    },
                    isFilterReset: true,
                    showAdvancedFilter: false
                },
                () => {
                    this.updateEntityParams();
                    this.refreshImageList();
                }
            );
        }
    };
    resetSort = () => {
        const { isAssignView } = this.state;
        const order = isAssignView ? { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER } : { name: "asc" };
        this.setState({ imageParams: { ...this.state.imageParams, order }, sortOrder: isAssignView ? ASSIGN_VIEW_DEFAULT_SORT_ORDER : "asc" }, () => {
            this.updateEntityParams();
            this.refreshImageList();
        });
    };

    handleChangeAssignFilter = value => {
        this.setState({ imageParams: { ...this.state.imageParams, not_assigned: value } });
        this.refreshImageList();
    };

    handleChangeFavFilter = value => {
        this.setState({ favFilter: value });
    };

    handleFavClick = async (id, favourite) => {
        await this.setState(prevState => {
            const imageList = prevState.imageList.map(item => {
                if (item.id === id) {
                    item.favourite = favourite;
                    return item;
                } else return item;
            });
            const selectedImages = prevState.selectedImages.map(item => {
                if (item.id === id) {
                    item.favourite = favourite;
                    return item;
                } else return item;
            });
            return { imageList, selectedImages };
        });

        this.props.addToFav({ id, favourite });
    };

    viewRecommendations = selectedImage => {
        const { imageList, showImageViewModal, showSelected, selectedImages } = this.state;
        const { entityPluralLabel } = this.getRecommendationEntityLabels();
        let currImgList = showSelected ? selectedImages : imageList;
        let selectedProject = selectedImage.project?.id || "";
        let selectedIndex = currImgList?.findIndex(item => item?.id === selectedImage?.id);
        sessionStorage.setItem("imageIndex", selectedIndex);
        sessionStorage.setItem("selectedImage", showImageViewModal ? JSON.stringify(selectedImage) : null);
        addToBreadCrumpData({
            key: "Name",
            name: selectedImage.name,
            path: `/images/imageInfo/${selectedImage.id}/recommendations?pid=${selectedProject}`
        });
        addToBreadCrumpData({
            key: "assignedInfo",
            name: entityPluralLabel,
            path: `/images/imageInfo/${selectedImage.id}/recommendations?pid=${selectedProject}`
        });
        history.push(`/images/imageInfo/${selectedImage.id}/recommendations?pid=${selectedProject}`);
    };
    viewAssets = selectedImage => {
        const { imageList, showImageViewModal, showSelected, selectedImages } = this.state;
        let currImgList = showSelected ? selectedImages : imageList;
        let selectedProject = selectedImage.project?.id || "";
        let selectedIndex = currImgList?.findIndex(item => item?.id === selectedImage?.id);
        sessionStorage.setItem("imageIndex", selectedIndex);
        sessionStorage.setItem("selectedImage", showImageViewModal ? JSON.stringify(selectedImage) : null);
        addToBreadCrumpData({
            key: "Name",
            name: selectedImage.name,
            path: `/images/imageInfo/${selectedImage.id}/assets?pid=${selectedProject}`
        });
        addToBreadCrumpData({
            key: "assignedInfo",
            name: "Assets",
            path: `/images/imageInfo/${selectedImage.id}/assets?pid=${selectedProject}`
        });
        history.push(`/images/imageInfo/${selectedImage.id}/assets?pid=${selectedProject}`);
    };

    updateEntityParams = async () => {
        const { imageParams, masterFilters, isGridView, sortOrder, isFilterReset, showSelected, selectedImages } = this.state;
        let entityParams = {
            imageParams,
            masterFilters,
            isGridView,
            sortOrder,
            isFilterReset,
            showSelected,
            selectedImages,
            type: this.entityParamsKey()
        };
        await this.props.updateEntityParams(entityParams);
    };

    resetEntityParams = async () => {
        await this.setState({
            isGridView: true,
            imageParams: {
                limit: 100,
                offset: 1,
                search: "",
                filters: {},
                order: this.state.isAssignView
                    ? { [ASSIGN_VIEW_DEFAULT_SORT_KEY]: ASSIGN_VIEW_DEFAULT_SORT_ORDER }
                    : { "image_upload.created_date": "desc" }
            },
            sortOrder: this.state.isAssignView ? ASSIGN_VIEW_DEFAULT_SORT_ORDER : "desc",
            masterFilters: {
                client_ids: [],
                project_ids: [],
                region_ids: [],
                site_ids: [],
                building_ids: [],
                trade_ids: [],
                system_ids: [],
                sub_system_ids: [],
                user_ids: [],
                image_tag_ids: [],
                uniformat_level_6_ids: [],
                uniformat_level_5_ids: []
            },
            isFilterReset: false,
            showSelected: false,
            selectedImages: []
        });
        this.updateEntityParams();
    };

    toggleShowSelected = async e => {
        e.preventDefault();
        await this.setState({ showSelected: !this.state.showSelected });
        this.updateEntityParams();
    };

    exportImages = async images => {
        let params = [];
        let project_id = images.every(img => img.project?.id === images[0]?.project?.id) ? images[0]?.project?.id : "";
        let building_name = images.every(img => img.building?.id === images[0]?.building?.id) ? images[0]?.building?.name : "";
        let trade_id = images.every(img => img.trade?.id === images[0]?.trade?.id) ? images[0]?.trade?.id : "";
        images.forEach(element => {
            const imageUrl = element?.is_edited ? element?.s3_eimage_key : element?.s3_image_key;
            params.push({
                key: imageUrl,
                caption: element.caption,
                building: element.building.name,
                name: element.name,
                trade: element.trade.name
            });
        });
        this.setState({ exportImageLoader: true });
        await this.props.exportImages({
            image_list: params,
            project_id,
            building_name,
            trade_id,
            username: localStorage.getItem("user"),
            user_id: localStorage.getItem("userId")
        });
        this.setState({ exportImageLoader: false });
    };

    exportImagesPdf = async images => {
        let params = [];
        let project_id = images.every(img => img.project?.name === images[0]?.project?.name) ? images[0]?.project?.id : "";
        let building_name = images.every(img => img.building?.id === images[0]?.building?.id) ? images[0]?.building?.name : "";
        let trade_id = images.every(img => img.trade?.id === images[0]?.trade?.id) ? images[0]?.trade?.id : "";
        images.forEach(element => {
            const imageUrl = element?.is_edited ? element?.s3_eimage_key : element?.s3_image_key;
            params.push({
                key: imageUrl,
                caption: element.caption,
                building: element.building.name,
                name: element.name,
                trade: element.trade.name
            });
        });
        this.setState({ exportImagePdfLoader: true });
        await this.props.exportImagesPdf({
            image_list: params,
            project_id,
            building_name,
            trade_id,
            username: localStorage.getItem("user"),
            user_id: localStorage.getItem("userId")
        });
        this.setState({ exportImagePdfLoader: false });
    };

    confirmImageZipDownload = images => {
        if (images?.length) {
            this.exportImagesZip(images);
        } else {
            this.setState({ showAllImageZipDownloadConfirmation: true });
        }
    };

    exportImagesZip = async images => {
        this.setState({ showAllImageZipDownloadConfirmation: false });
        let params = {
            client_ids: this.state.masterFilters?.client_ids || [],
            username: localStorage.getItem("user")
        };
        if (images?.length) {
            this.setState({ exportImageZipLoader: "selectedImageLoader" });
            params.image_ids = images.map(img => img.id);
        } else {
            this.setState({ exportImageZipLoader: "wholeImageLoader" });
            let { limit, offset, order, ...rest } = this.state.imageParams;
            const [key, value] = Object.entries(order)?.[0];
            const newSortKey = SORT_KEYS.find(sort => sort.sortKey === key)?.exportSortKey;
            const newOrder = { [newSortKey]: value };
            params = {
                ...params,
                image_filters: {
                    order: newOrder,
                    ...rest
                }
            };
        }
        await this.props.exportImagesZip(params);
        this.setState({ exportImageZipLoader: false });
    };
    handleNext = id => {
        const { selectedImages, showSelected } = this.state;
        let imageList = this.state.imageList;
        imageList = showSelected ? selectedImages : imageList;
        let current_index = imageList?.findIndex(item => item.id === id);
        let selectedImage = imageList[current_index + 1];
        selectedImage?.id && this.viewImageModal(selectedImage);
    };

    updateImagesAfterEdit = async (id, isEdit = false) => {
        const { success, s3_image_key, thumbnail_image_key } = this.props.imageReducer.saveEditedImageResponse;
        if (success) {
            await this.setState(prevState => {
                const imageList = prevState.imageList.map(item => {
                    if (item.id === id) {
                        item.is_edited = isEdit;
                        item.s3_eimage_key = isEdit ? s3_image_key : "";
                        item.s3_ethumbnail_key = isEdit ? thumbnail_image_key : "";
                        return item;
                    } else return item;
                });
                const selectedImages = prevState.selectedImages.map(item => {
                    if (item.id === id) {
                        item.is_edited = isEdit;
                        item.s3_eimage_key = isEdit ? s3_image_key : "";
                        item.s3_ethumbnail_key = isEdit ? thumbnail_image_key : "";
                        return item;
                    } else return item;
                });
                return { imageList, selectedImages };
            });
        }
    };

    updateImageListAfterUpdate = async (data, editedImages) => {
        const {
            imageReducer: {
                projectList: { projects },
                buildingList: { buildings },
                tradeList: { trades },
                systemList: { systems },
                subsystemList: { sub_systems }
            },
            assetReducer: { dropDownList }
        } = this.props;
        const { editedData, removed_tags, tags } = data;
        editedImages.forEach(({ id }) => {
            this.setState(prevState => {
                const imageList = prevState.imageList.map(item => {
                    if (item.id === id) {
                        // updating the existing images if any data changed
                        item.project = editedData.hasOwnProperty("project_id")
                            ? projects?.filter(p => p.id === editedData.project_id)[0] || {}
                            : item.project;
                        item.building = editedData.hasOwnProperty("building_id")
                            ? buildings?.filter(p => p.id === editedData.building_id)[0] || {}
                            : item.building;
                        item.trade = editedData.hasOwnProperty("trade_id") ? trades?.filter(p => p.id === editedData.trade_id)[0] || {} : item.trade;
                        item.system = editedData.hasOwnProperty("system_id")
                            ? systems?.filter(p => p.id === editedData.system_id)[0] || {}
                            : item.system;
                        item.sub_system = editedData.hasOwnProperty("subsystem_id")
                            ? sub_systems?.filter(p => p.id === editedData.subsystem_id)[0] || {}
                            : item.sub_system;
                        item.caption = editedData.hasOwnProperty("caption") ? editedData.caption : item.caption;
                        item.updated_at = moment().format();

                        item.client = editedData.hasOwnProperty("client_id")
                            ? dropDownList?.clients?.filter(p => p.id === editedData.client_id)[0] || {}
                            : item.client;
                        item.region = editedData.hasOwnProperty("region_id")
                            ? dropDownList?.regions?.filter(p => p.id === editedData.region_id)[0] || {}
                            : item.region;
                        item.site = editedData.hasOwnProperty("site_id")
                            ? dropDownList?.sites?.filter(p => p.id === editedData.site_id)[0] || {}
                            : item.site;
                        // removing the the tags
                        if (removed_tags.length) {
                            item.labels = item.labels.filter(fi => removed_tags.forEach(rem => rem !== fi.name));
                        }
                        // adding newly created tags
                        tags.forEach(tag => {
                            if (item.labels.findIndex(lab => lab.name === tag) === -1) {
                                item.labels.push({ name: tag });
                            }
                        });
                        return item;
                    } else return item;
                });
                const selectedImages = prevState.selectedImages.map(item => {
                    if (item.id === id) {
                        // updating the existing images if any data changed
                        item.project = editedData.hasOwnProperty("project_id")
                            ? projects?.filter(p => p.id === editedData.project_id)[0] || {}
                            : item.project;
                        item.building = editedData.hasOwnProperty("building_id")
                            ? buildings?.filter(p => p.id === editedData.building_id)[0] || {}
                            : item.building;
                        item.trade = editedData.hasOwnProperty("trade_id") ? trades?.filter(p => p.id === editedData.trade_id)[0] || {} : item.trade;
                        item.system = editedData.hasOwnProperty("system_id")
                            ? systems?.filter(p => p.id === editedData.system_id)[0] || {}
                            : item.system;
                        item.sub_system = editedData.hasOwnProperty("subsystem_id")
                            ? sub_systems?.filter(p => p.id === editedData.subsystem_id)[0] || {}
                            : item.sub_system;
                        item.caption = editedData.hasOwnProperty("caption") ? editedData.caption : item.caption;
                        item.updated_at = moment().format();

                        item.client = editedData.hasOwnProperty("client_id")
                            ? dropDownList?.clients?.filter(p => p.id === editedData.client_id)[0] || {}
                            : item.client;
                        item.region = editedData.hasOwnProperty("region_id")
                            ? dropDownList?.regions?.filter(p => p.id === editedData.region_id)[0] || {}
                            : item.region;
                        item.site = editedData.hasOwnProperty("site_id")
                            ? dropDownList?.sites?.filter(p => p.id === editedData.site_id)[0] || {}
                            : item.site;
                        // removing the the tags
                        if (removed_tags.length) {
                            item.labels = item.labels.filter(fi => removed_tags.forEach(rem => rem !== fi.name));
                        }
                        // adding newly created tags
                        tags.forEach(tag => {
                            if (item.labels.findIndex(lab => lab.name === tag) === -1) {
                                item.labels.push({ name: tag });
                            }
                        });
                        return item;
                    } else return item;
                });

                return { imageList, selectedImages };
            });
        });
    };

    handlePrev = id => {
        const { selectedImages, showSelected } = this.state;
        let imageList = this.state.imageList;
        imageList = showSelected ? selectedImages : imageList;
        let current_index = imageList?.findIndex(item => item.id === id);
        let selectedImage = imageList[current_index - 1];
        selectedImage?.id && this.viewImageModal(selectedImage);
    };
    handleNextForm = id => {
        const { selectedImages, showSelected } = this.state;
        let imageList = this.state.imageList;
        imageList = showSelected ? selectedImages : imageList;
        let current_index = imageList?.findIndex(item => item.id === id);
        let selectedImage = imageList[current_index + 1];
        this.handleEditImage(selectedImage, "next");
    };
    handlePrevForm = id => {
        const { selectedImages, showSelected } = this.state;
        let imageList = this.state.imageList;
        imageList = showSelected ? selectedImages : imageList;
        let current_index = imageList?.findIndex(item => item.id === id);
        let selectedImage = imageList[current_index - 1];
        this.handleEditImage(selectedImage, "prev");
    };
    handleInputCaptionData = async caption => {
        let caption_id = caption?.image_ids[0];
        if (caption_id) {
            this.setState(prevState => {
                const imageList = prevState.imageList.map(item => {
                    if (item.id === caption_id) {
                        item.caption = caption?.caption;
                        return item;
                    } else return item;
                });
                const selectedImages = prevState.selectedImages.map(item => {
                    if (item.id === caption_id) {
                        item.caption = caption?.caption;
                        return item;
                    } else return item;
                });
                return { imageList, selectedImages };
            });
        }
    };

    renderAllImageZipDownloadConfirmationModal = () => {
        const { showAllImageZipDownloadConfirmation, totalCount } = this.state;
        if (!showAllImageZipDownloadConfirmation) return null;
        const count = totalCount > 500 ? 500 : totalCount;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Are you sure you want to download ${count} image(s)?`}
                        message={``}
                        onNo={() => this.setState({ showAllImageZipDownloadConfirmation: false })}
                        onYes={this.exportImagesZip}
                        type="cancel"
                    />
                }
                onCancel={() => this.setState({ showAllImageZipDownloadConfirmation: false })}
            />
        );
    };
    handleImageDownloadModal = async () => {
        this.setState({ showImageDownloadModal: true });
    };
    imageExport = async selectedValue => {
        await this.props.imageBulkDownload({
            client_id: this.state.masterFilters.client_ids?.[0],
            site_ids: this.state.masterFilters.site_ids,
            building_ids: this.state.masterFilters.building_ids,
            is_remove_uuid: true,
            ...selectedValue,
            project_id: this.state.masterFilters.project_ids?.[0] ?? selectedValue?.project_id
        });
        if (this.props.imageReducer?.imageBulkDownloadResponse) {
            this.setState(
                {
                    alertMessage:
                        this.props.imageReducer?.imageBulkDownloadResponse?.message ??
                        this.props.imageReducer?.imageBulkDownloadResponse?.detail ??
                        ""
                },
                () => this.showLongAlert()
            );
        }
        if (this.props.imageReducer?.imageBulkDownloadResponse?.success) {
            this.setState({ showImageDownloadModal: false });
        }
    };
    renderBulkImageDownloadModal = () => {
        const { showImageDownloadModal } = this.state;
        if (!showImageDownloadModal) return null;
        return (
            <Portal
                body={
                    <BulkImageDownload
                        masterFilters={this.state.masterFilters}
                        clientIds={this.state.masterFilters?.client_ids?.[0]}
                        imageExport={this.imageExport}
                        cancelForm={() => this.setState({ showImageDownloadModal: false })}
                        isLoading={this.props.imageReducer?.imageBulkDownloadResponse?.isLoading}
                        totalCount={this.state?.totalCount || 0}
                    />
                }
                onCancel={() => {}}
            />
        );
    };
    toggleFilesModal = () => {
        this.setState({
            openFiles: !this.state.openFiles
        });
    };
    renderFileModal = () => {
        const { openFiles } = this.state;
        if (!openFiles) return null;
        return (
            <Portal
                body={
                    <ExportedFiles
                        clientId={this.state.masterFilters?.client_ids}
                        projectId={this.state.masterFilters?.project_ids}
                        onCancel={this.toggleFilesModal}
                        masterFilter={this.state?.masterFilters}
                    />
                }
                onCancel={this.toggleFilesModal}
            />
        );
    };

    render() {
        const {
            showAdvancedFilter,
            isGridView,
            hasMore,
            showSelectBox,
            selectedImages,
            imageParams,
            totalCount,
            sortOrder,
            isLoading,
            isAssignView,
            masterFilters,
            favFilter,
            showSelected,
            exportImageLoader,
            exportImagePdfLoader,
            exportImageZipLoader,
            touchedImageId
        } = this.state;
        const { isSmartChartView = false, entity } = this.props;
        let hasEdit = checkPermission("forms", "image_management", "edit") && this.props?.entity !== entities.SMART_CHARTS_IMAGE;
        let hasCreate = checkPermission("forms", "image_management", "create") && this.props?.entity !== entities.SMART_CHARTS_IMAGE;
        let hasDelete = checkPermission("forms", "image_management", "delete") && this.props?.entity !== entities.SMART_CHARTS_IMAGE;
        let hasExport = checkPermission("forms", "image_management", "export") && this.props?.entity !== entities.SMART_CHARTS_IMAGE;
        let imageList = this.state.imageList;
        imageList = showSelected ? selectedImages : imageList;

        const { entityPluralLabel, entityLabel } = this.getRecommendationEntityLabels();
        const {
            match: {
                params: { tab, section }
            }
        } = this.props;
        const { isStandardImage = false, isGlobalStandards = false, isSurveyUniformat = false, isGlobalUniformat = false } = this.props || {};

        return (
            <LoadingOverlay active={isLoading} spinner={<Loader />} fadeSpeed={10}>
                <>
                    {this.renderImageClearConfirmationModal()}
                    <div
                        className={`dtl-sec col-md-12 image-manage ${isAssignView && `pull-img-box`} ${showAdvancedFilter ? "filter-open" : ""} ${
                            selectedImages?.length ? "select-open" : ""
                        }`}
                        id="main"
                    >
                        {this.renderUploadModal()}
                        {this.renderUploadSingleModal()}
                        {this.renderImageViewModal()}
                        {this.renderLogsModal()}
                        {this.renderConfirmationModal()}
                        {this.renderAllImageZipDownloadConfirmationModal()}
                        {this.renderBulkImageDownloadModal()}
                        {this.renderFileModal()}
                        <>
                            <div className="flt-area-new">
                                <MasterFilter
                                    toggleAdvancedFilters={this.toggleAdvancedFilters}
                                    onAddImage={this.handleAddImage}
                                    setGridView={this.setGridView}
                                    updateMasterFilters={this.updateMasterFilters}
                                    isAssignView={isAssignView}
                                    imageParams={imageParams}
                                    hasCreate={isStandardImage || isSurveyUniformat || isGlobalUniformat ? false : hasCreate}
                                    // handleValueSelect={this.handleMasterFilterSelect}
                                    // handleValueSelectAll={this.handleMasterFilterSelectAll}
                                    masterFilters={masterFilters}
                                    isSmartChartView={isSmartChartView}
                                    isAsset={this.props.isAsset}
                                    entity={entity}
                                    isSurveyAsset={this.props.isSurveyAsset}
                                    isInaccessible={this.props.isInaccessible}
                                    isStandardImage={isStandardImage ?? false}
                                    isGlobalStandards={isGlobalStandards ?? false}
                                    isGlobalUniformat={isGlobalUniformat ?? false}
                                    isUniformatImage={(isSurveyUniformat || isGlobalUniformat) ?? false}
                                    isMobRecom={this.props?.isMobRecom ?? false}
                                    levelNumber={this.props?.levelNumber ?? null}
                                />
                                {showAdvancedFilter && (
                                    <AdvancedFilter
                                        filters={imageParams.filters}
                                        updateAdvancedFilters={this.updateAdvancedFilters}
                                        updateRecomAssignedFilter={this.updateRecomAssignedFilter}
                                        updateClientStandardImage={this.updateClientStandardImage}
                                        updateImageModifyFilter={this.updateImageModifyFilter}
                                        updateAssetImage={this.updateAssetImage}
                                        imageParams={imageParams}
                                        entityPluralLabel={entityPluralLabel}
                                        isStandardImage={isStandardImage ?? false}
                                        isUniformatImage={(isSurveyUniformat || isGlobalUniformat) ?? false}
                                        updateUniformatImage={this.updateUniformatImage}
                                    />
                                )}
                            </div>
                            {this.props.imageAnalysisMode && (
                                <ImageAnalysisRunBar
                                    selectedImages={selectedImages}
                                    imageParams={imageParams}
                                    totalCount={this.state.totalCount}
                                    // Gate at the RENDER SITE: only `manage` may spend money. `view` still
                                    // sees a run's progress. The backend refuses the calls either way.
                                    canAnalyse={canUseOttoPage(OTTO_PAGES.IMAGE_ANALYSIS, OTTO_ACTIONS.MANAGE)}
                                    onRunFinished={this.refreshAnalysedBadges}
                                />
                            )}
                            <TopControls
                                showLogs={this.toggleLogsModal}
                                onEditImage={this.handleMultiEditImage}
                                selectedImages={selectedImages}
                                imageList={imageList}
                                handleSelectAll={this.handleSelectAll}
                                handleGlobalSearch={this.handleGlobalSearch}
                                params={imageParams}
                                handleSort={this.handleSort}
                                handleSortOrder={this.handleSortOrder}
                                sortOrder={sortOrder}
                                isAssignView={isAssignView}
                                resetAllFilters={this.resetAllFilters}
                                resetSort={this.resetSort}
                                hasEdit={hasEdit}
                                handleChangeAssignFilter={this.handleChangeAssignFilter}
                                assignFilter={this.state.imageParams.not_assigned}
                                refreshImages={this.refreshImageList}
                                refreshTableConfig={this.fetchTableConfig}
                                handleChangeFavFilter={this.handleChangeFavFilter}
                                favFilter={favFilter}
                                resetAll={this.resetAll}
                                toggleShowSelected={this.toggleShowSelected}
                                showSelected={showSelected}
                                exportImages={this.exportImages}
                                exportImagesPdf={this.exportImagesPdf}
                                exportImagesZip={this.confirmImageZipDownload}
                                exportImageLoader={exportImageLoader}
                                exportImagePdfLoader={exportImagePdfLoader}
                                exportImageZipLoader={exportImageZipLoader}
                                isSmartChartView={isSmartChartView}
                                totalCount={totalCount}
                                handleViewLastVisitedImage={this.handleViewLastVisitedImage}
                                showLastVisitedImage={this.state.lastVisitedImage}
                                fetchPreviousImages={this.fetchPreviousImages}
                                showLoadButton={imageList?.length > 1 && imageList[0]?.offset !== 1}
                                hasExport={hasExport}
                                hasImageDownload={
                                    masterFilters?.client_ids?.length === 1 &&
                                    (masterFilters?.site_ids?.length >= 1 || masterFilters?.building_ids?.length >= 1)
                                }
                                hasFileDownload={masterFilters?.project_ids?.length >= 1 || masterFilters?.client_ids?.length >= 1}
                                handleImageDownloadModal={this.handleImageDownloadModal}
                                showFiles={this.toggleFilesModal}
                                hasShowBtn={entity !== entities.SMART_CHARTS_IMAGE}
                            />
                        </>
                        {isGridView ? (
                            <div className={`infinite-scroll-component infinite-scroll`}>
                                <AutoSizer>
                                    {({ width, height }) => {
                                        width = width - 10;
                                        return (
                                            <div className={"image-sec"} style={{ width, height }}>
                                                {imageList?.length > 0 ? (
                                                    <ImageGrid
                                                        imageData={imageList}
                                                        showSelectBox={showSelectBox}
                                                        handleMultiSelectImage={this.handleMultiSelectImage}
                                                        selectedImages={selectedImages}
                                                        viewImageModal={this.viewImageModal}
                                                        handleEdit={this.handleEditImage}
                                                        handleDelete={this.handleDeleteImage}
                                                        fetchMoreImages={this.fetchMoreImages}
                                                        hasMore={hasMore}
                                                        isAssignView={isAssignView}
                                                        hasDelete={hasDelete}
                                                        hasEdit={hasEdit}
                                                        handleFavClick={this.handleFavClick}
                                                        viewRecommendations={this.viewRecommendations}
                                                        height={height}
                                                        width={width}
                                                        handleInputCaptionData={this.handleInputCaptionData}
                                                        viewAssets={this.viewAssets}
                                                        listRef={this.scrollRef}
                                                        touchedImageId={touchedImageId}
                                                        isSmartChartView={isSmartChartView}
                                                        isNextPageLoading={this.state.isNextPageLoading}
                                                        entityPluralLabel={entityPluralLabel}
                                                        entityLabel={entityLabel}
                                                        imageBadges={this.state.imageBadges}
                                                    />
                                                ) : (
                                                    <div className="text-center">No Images Found</div>
                                                )}
                                            </div>
                                        );
                                    }}
                                </AutoSizer>
                            </div>
                        ) : (
                            <div className={"cnt-sec"}>
                                {imageList?.length > 0 ? (
                                    <ImageList
                                        imageData={imageList}
                                        showSelectBox={showSelectBox}
                                        handleMultiSelectImage={this.handleMultiSelectImage}
                                        selectedImages={selectedImages}
                                        viewImageModal={this.viewImageModal}
                                        handleEdit={this.handleEditImage}
                                        handleDelete={this.handleDeleteImage}
                                        fetchMoreImages={this.fetchMoreImages}
                                        hasMore={hasMore}
                                        isAssignView={isAssignView}
                                        hasDelete={hasDelete}
                                        hasEdit={hasEdit}
                                        handleFavClick={this.handleFavClick}
                                        viewRecommendations={this.viewRecommendations}
                                        handleInputCaptionData={this.handleInputCaptionData}
                                        entityPluralLabel={entityPluralLabel}
                                        entityLabel={entityLabel}
                                        imageBadges={this.state.imageBadges}
                                    />
                                ) : (
                                    <div className="text-center"> No Images Found</div>
                                )}
                            </div>
                        )}
                        <BottomControls
                            handleLimitChange={this.handleLimitChange}
                            loadedCount={imageList.length}
                            totalCount={totalCount}
                            limit={imageParams.limit}
                        />
                    </div>
                </>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = state => {
    const { imageReducer, assetReducer, projectReducer } = state;
    return { imageReducer, assetReducer, projectReducer };
};

export default withRouter(connect(mapStateToProps, { ...actions })(ImageMain));
